import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import createRoot from 'react-dom/client';
import { store } from './redux/store/store';
import { Provider } from 'react-redux';
import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { MsalProvider } from '@azure/msal-react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import '../node_modules/@pds/navigationPrimary/navigationPrimary.min.css'
import '../node_modules/@pds/navigationPrimary/navigationPrimary.min.js'
import '../node_modules/@pds/avatar/avatar.min.css'
import '../node_modules/@pds/avatar/avatar.min.js'
import '../node_modules/@pds/button/button.min.css'
import '../node_modules/@pds/button/button.min.js'
import '../node_modules/@pds/tooltip/tooltip.min.css'
import '../node_modules/@pds/tooltip/tooltip.min.js'
import '../node_modules/@pds/productCard/productCard.min.css'
import '../node_modules/@pds/productCard/productCard.min.js'
import '../node_modules/@pds/table/table.min.css'
import '../node_modules/@pds/table/table.min.js'
import '../node_modules/@pds/dataTable/dataTable.min.css'
import '../node_modules/@pds/dataTable/dataTable.min.js'
import '../node_modules/@pds/tableActionMenu/tableActionMenu.min.css'
import '../node_modules/@pds/tableActionMenu/tableActionMenu.min.js'
import '../node_modules/@pds/collapsible/collapsible.min.css'
import '../node_modules/@pds/collapsible/collapsible.min.js'
import '../node_modules/@pds/animatedIcon/animatedIcon.min.css'
import '../node_modules/@pds/animatedIcon/animatedIcon.min.js'
import '../node_modules/@pds/modal/modal.min.css'
import '../node_modules/@pds/modal/modal.min.js'
import '../node_modules/@pds/externalRedirectMessage/externalRedirectMessage.min.css'
import '../node_modules/@pds/externalRedirectMessage/externalRedirectMessage.min.js'
import '../node_modules/@pds/collapsible/collapsible.min.css'
import '../node_modules/@pds/collapsible/collapsible.min.js'
import '../node_modules/@pds/input/input.min.css'
import '../node_modules/@pds/input/input.min.js'
import '../node_modules/@pds/searchInput/searchInput.min.css'
import '../node_modules/@pds/searchInput/searchInput.min.js'
import '../node_modules/@pds/erroredInput/erroredInput.min.css'
import '../node_modules/@pds/erroredInput/erroredInput.min.js'
import '../node_modules/@pds/select/select.min.css'
import '../node_modules/@pds/select/select.min.js'
import '../node_modules/@pds/erroredSelect/erroredSelect.min.css'
import '../node_modules/@pds/erroredSelect/erroredSelect.min.js'
import '../node_modules/@pds/helperSelect/helperSelect.min.css'
import '../node_modules/@pds/helperSelect/helperSelect.min.js'
import '../node_modules/@pds/helperInput/helperInput.min.css'
import '../node_modules/@pds/helperInput/helperInput.min.js'
import '../node_modules/@pds/serverError/serverError.min.css'
import '../node_modules/@pds/serverError/serverError.min.js'
import '../node_modules/@pds/notFoundError/notFoundError.min.css'
import '../node_modules/@pds/notFoundError/notFoundError.min.js'
import '../node_modules/@pds/maintenanceError/maintenanceError.min.css'
import '../node_modules/@pds/maintenanceError/maintenanceError.min.js'
import '../node_modules/@pds/maintenanceError/maintenanceError.min.css'
import '../node_modules/@pds/radio/radio.min.css'
import '../node_modules/@pds/radio/radio.min.js'




const Mantainers = lazy(() => import('./pages/Maintainers/Maintainers'));
import PrimaryNavigation from './components/core/PrimaryNavigation/PrimaryNavigation';
import MeRepositorys from './pages/MeRepositorys/MeRepositorys';
import RepositoryRequest from './pages/RepositoryRequest/RepositoryRequest';
import Upload from './pages/Upload/Upload';
import Home from './pages/Home/Home';
import RouteGuard from './components/core/RouteGuard/RouteGuard';
import ErrorPage  from './pages/ErrorPages/ErrorPage';
import MaintainerDetail from './pages/MaintainerDetail/MantainerDetail';
import MaintainerAddingGroup from './pages/MantainerAddingGroup/MaintainerAddingGroup';
import RepositoryContent from './pages/RepositoryContent/RepositoryContent';
import PortalDocuments from './pages/PortalDocuments/PortalDocuments';
import AdminRequest from './pages/AdminRequests/AdminRequest';
import PortalDocumentsMeRepositories from './pages/PortalDocumentsMeRepositories/PortalDocumentsMeRepositories';
import NewRepositories from './pages/NewRepositories/NewRepositories';
import AdminRepositories from './pages/AdminRepositories/AdminRepositories';
import AdminRepositoryRequest from './pages/AdminRepositoryRequests/AdminRepositoryRequest';
import PortalDocumentsAccess from './pages/PortalDocumentsAccess/PortalDocumetsAccess';
import AdminRepositoryAccess from './pages/AdminRepositoryAccess/AdminRepositoryAccess';
import AdminRequestDocument from './pages/AdminRequestDocument/AdminRequestDocument';
import Intermediatelanding from './pages/IntermediateLanding/IntermediateLanding';

export const msalInstance = new PublicClientApplication(msalConfig);
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
  console.log('addEventCallback...');
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <Provider store={store}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/errorpage" element={<ErrorPage />} />
            <Route path="/documents" element={React.createElement(()=><RouteGuard component={RepositoryContent} scopes={["*"]} modules={["document"]}/>)} />
            <Route path="/new-repository" element={<NewRepositories/>}/>
            <Route path="/my-repositories" element={<PortalDocumentsMeRepositories/>}/>
            <Route path="/repositories" element={<PortalDocuments/>}/>
            <Route path="/repositories/get-access" element={<PortalDocumentsAccess/>}/>
            <Route path="/admin-repositories" element={React.createElement(()=><RouteGuard component={AdminRepositories} scopes={["*"]} modules={["document"]}/>)} />
            <Route path="/admin-request" element={React.createElement(()=><RouteGuard component={AdminRequest} scopes={["*"]} modules={["document"]}/>)} />
            <Route path="/group-mantainers" element={React.createElement(()=><RouteGuard component={MaintainerAddingGroup} scopes={["*"]} modules={["document"]}/>)} />
            <Route path="/groups-mantainers" element={React.createElement(()=><RouteGuard component={MaintainerDetail} scopes={["*"]} modules={["document"]}/>)} />
            <Route path="/group-mantainer" element={React.createElement(()=><RouteGuard component={Mantainers} scopes={["*"]} modules={["document"]}/>)} />
            <Route path="/documents/uploadocument" element={React.createElement(() =><RouteGuard component={Upload} scopes={["*"]} modules={["document"]}/>)} />
            <Route path="/repository-access-request/:id" element={<AdminRepositoryAccess/>} />
            <Route path="/repository-request/:id"  element={<AdminRepositoryRequest/>}/>
            <Route path="/document-deletion-request/:repositoryname/:id" element={<AdminRequestDocument/>}/>
            
            <Route path="/loginlanding" element={<Intermediatelanding/>}/>
            
          </Routes>
        </Provider>
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>,
);
reportWebVitals();
